import script from "./2.HaveReceivedBotoxAndOthers.vue?vue&type=script&setup=true&lang=ts"
export * from "./2.HaveReceivedBotoxAndOthers.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__